import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, ModelObjectWithDirtyCheck, type ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class DeliveryNotificationSettings extends ModelObject<DeliveryNotificationSettings> {

    public version: number = 0;
    /**
    * Whether despatch notifications should be sent by Email for this tenant.
    */
    public sendDespatchNotificationEmails: boolean = false;
    /**
    * Reply To address to use when sending emails.
    * Not Nullable
    * Max Length : 1000
    */
    public emailReplyToAddress: string = "";

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.version = jsonSerializedObject.version;
          this.sendDespatchNotificationEmails = jsonSerializedObject.sendDespatchNotificationEmails;
          this.emailReplyToAddress = jsonSerializedObject.emailReplyToAddress;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.version = this.version;
        toRet.sendDespatchNotificationEmails = this.sendDespatchNotificationEmails;
        toRet.emailReplyToAddress = this.emailReplyToAddress;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "version", rule: (v: any) => v == null || v >= -9223372036854775808 || "Version is not greater than minimum allowed value: -9223372036854775808"},
            {field: "version", rule: (v: any) => v == null || v <= 9223372036854775807 || "Version is above maximum allowed value: 9223372036854775807"},
            {field: "emailReplyToAddress", rule: (v: any) => v == null || v.length <= 1000 || "EmailReplyToAddress has too many characters (1000)"},
    ];
}


export class DeliveryNotificationService extends ServiceBase {

  public async getDeliveryNotificationSettings(opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<DeliveryNotificationSettings> {
    const req = {
    tenantId:api.tenantId.toString(),
    };
    const extractor = (response:any) => new DeliveryNotificationSettings(response.deliveryNotificationSettings);;
    return this.makeJsonRequest("deliveryNotification/v1/getDeliveryNotificationSettings", req, false, extractor, opts);
  };

  public async saveDeliveryNotificationSettings(deliveryNotificationSettings: DeliveryNotificationSettings, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:api.tenantId.toString(),
    deliveryNotificationSettings:deliveryNotificationSettings.toJsonSerializedObject(),
    };
    const extractor = null;
    return this.makeJsonRequest("deliveryNotification/v1/saveDeliveryNotificationSettings", req, true, extractor, opts);
  };

  public async generateDespatchNotificationText(textTemplate: string, journeyId: Guid, orderId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<string> {
    const req = {
    tenantId:api.tenantId.toString(),
    textTemplate:textTemplate,
    journeyId:journeyId.toString(),
    orderId:orderId.toString(),
    };
    const extractor = (response:any) => response.result;;
    return this.makeJsonRequest("deliveryNotification/v1/generateDespatchNotificationText", req, false, extractor, opts);
  };
}

export const deliveryNotificationService = new DeliveryNotificationService();